import { Tooltip, Button } from '@mui/material';
import { ThemeSettings } from 'src/theme/Theme';

// const ActionIconBtn = ({ icon: Icon, tooltipTitle, onClick, bgColor='#adc3fa', hoverColor='#dbe5ff' }) => {
const ActionIconBtn = ({ icon: Icon, tooltipTitle, onClick, bgColor, hoverColor, sx }: any) => {
  const theme = ThemeSettings();
  return (
    <Tooltip title={tooltipTitle}>
      <Button
        variant="contained"
        onClick={onClick}
        sx={{
          ...ActionIconBtn_Styles(bgColor, hoverColor),
          ...sx,
        }}
      >
        <Icon stroke={1.3} style={{ fill: '', stroke: '' }} />
      </Button>
    </Tooltip>
  );
};

export default ActionIconBtn;

export const ActionIconBtn_Styles = (bgColor?: string, hoverColor?: string, btnHeight?: string, ) => {
  const theme = ThemeSettings();

  return {
    padding: 1.5,
    minWidth: 'min-content',
    borderRadius: '9rem',
    maxHeight: '55px',
    maxWidth: '55px',
    height: btnHeight || '45px',
    width: btnHeight || '45px',
    aspectRatio: '1/1',
    // backgroundColor: bgColor || theme.palette.purple.A400,
    // color: theme.palette.text.primary,
    backgroundColor: bgColor || theme.palette.primary.light,
    color: theme.palette.primary.main,
    '&:hover': {
      // backgroundColor: hoverColor || theme.palette.purple.A75,
      // color: theme.palette.text.secondary,
      backgroundColor: hoverColor || theme.palette.background.BrokenWhite,
      color: theme.palette.primary.main,
    },
    '& svg': {
      // height: btnHeight || '23px',
      // width: btnHeight || '100%',
      // aspectRatio: '1/1',
    },
  };
};
